export const login = data => dispatch => {
  dispatch({
    type: 'LOGIN',
    data,
  });
};

export const logout = () => dispatch => {
  dispatch({
    type: 'LOGOUT',
  });
};

export const setAuth = () => dispatch => {
  dispatch({
    type: 'SET_AUTH',
  });
};
